//  https://smartdevpreneur.com/the-essential-mui-tooltip-demo-with-custom-position-arrow-and-internal-components/

import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

interface styledProps {
  className?: string;
  title: JSX.Element;
  children: JSX.Element;
  open: boolean;
  placement: any;
  arrow: boolean;
  maxwidth?: number;
  left?: string;
}

export const HtmlTooltip = styled((props: styledProps) => (
  <Tooltip {...props} classes={{ popper: props.className }} />
))(({ theme, maxwidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'lightsteelblue',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: maxwidth,
    paddingTop: '15px',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));